import type { FanResponseDto, OnlyFansList } from '@api'

import { MessageSendRequest } from '@/modules/chatting/types'

export const createMassMessageBody = ({
  message,
  includedUsers = [],
  includedLists = [],
  excludedUsers = [],
  excludedLists = [],
  total,
}: {
  message: Partial<MessageSendRequest>
  includedUsers?: FanResponseDto['id'][]
  includedLists?: OnlyFansList['id'][]
  excludedUsers?: FanResponseDto['id'][]
  excludedLists?: OnlyFansList['id'][]
  total: number
}): Partial<MessageSendRequest> & { totalRecepientsCount: number } => {
  const massMessage = {
    ...message,
    totalRecepientsCount: total,
  }

  if (includedUsers.length) {
    massMessage.userIds = includedUsers
  }

  if (includedLists.length) {
    massMessage.userLists = includedLists
  }

  if (excludedLists.length) {
    massMessage.excludedLists = excludedLists
  }

  if (excludedUsers.length) {
    massMessage.excludeUserIds = excludedUsers
  }

  return massMessage
}
